export const customStyles = {
  control: (provided) => ({
    ...provided,
    padding: "4px 16px",
    border: "1px solid var(--neutral-gray-gray, #5656b93c)",
    width: "100%", // Make sure control is full width
    borderRadius: "16px",
    background: "var(--neutral-light-purple, #f4f4ff)",
    boxShadow: "0px 0px 7px 0px rgba(207, 190, 255, 0.22)",
    color: "#5656b9",
    minHeight: "auto", // Override to handle padding
  }),
  // You might want to adjust the width of the menu to match the control
  container: (provided) => ({
    ...provided,
    width: "100%", // Ensure the dropdown menu is also full width
    color: "#5656b9",
    
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#a2a2ff",
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? "gray" : provided.color,
    borderBottom: "0.5px solid gray",
    padding: "10px",
    
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#F4F4FF",
    boxShadow: "0px 0px 7px 0px rgba(207, 190, 255, 0.22)",
    borderRadius: "24px",
    padding: "16px",
    marginTop: "10px",
    border: "1px solid var(--neutral-gray-gray, #5656b93c)",
  }),
};

export const filterStyles = {
  control: (provided) => ({
    ...provided,
    background: "#ffffff",
    padding: "4px 16px",
    borderRadius: "16px",
    border: "none",
    boxShadow: "0px 0px 7px 0px rgba(207, 190, 255, 0.22)",
    color: "#5656b9",
  }),
  container: (provided) => ({
    ...provided,
    width: "150px",
    color: "#5656b9",
  }),
  option: (provided) => ({
    ...provided,
    color: "#5656b9",
    borderBottom: "0.5px solid gray",
    padding: "16px",
    marginTop: "5px"
  }),
  menu: (provided) => ({
    ...provided,
    width: "200px",
    backgroundColor: "#FFFFFF",
    boxShadow: "7px 7px 7px 0px rgba(207, 190, 255, 0.22)",
    borderRadius: "24px",
    padding: "16px",
    marginTop: "10px",
    zIndex: 1000
  })
}